import React, { PropsWithChildren } from 'react'

import { BorderStyle, Box, Color, DisplayPosition } from '@gousto-internal/citrus-react'

type ContentMaskProps = {
  className?: string
}

export const ContentMask = ({ className = '', children }: PropsWithChildren<ContentMaskProps>) => (
  <Box className={className} data-testid="content-mask">
    <Box
      bg={Color.White}
      borderBottomWidth={0.5}
      borderTopWidth={0.5}
      borderColor={Color.ColdGrey_200}
      borderStyle={BorderStyle.Solid}
      color={Color.ColdGrey_800}
      position={DisplayPosition.Relative}
    >
      <Box paddingBottom={10} paddingV={4}>
        {children}
      </Box>
    </Box>
  </Box>
)
